import React from "react";
import "./NKYDispensary.css";

const ClinicMedications = () => {
  return (
    <section className=" subpage subpage-nky-dispensary">
      <article className="subpage-content">
        <header>
          <h1>GET YOUR SPECIALITY MEDICATIONS AT OUR CLINIC</h1>
        </header>
        <p>
          In order to provide the most comprehensive care, NKY Arthritis now
          offers patients the option to fill specialty medication with our
          practice. Through our Medically Integrated Dispensary (MID), NKY
          Arthritis providers can closely manage treatments in coordination with
          our MID team to ensure the best outcomes possible.
        </p>
        <p>
          We offer patients:
          <ul>
            <li>
              Dedicated clinical support from pharmacists and care coordinators
            </li>
            <li>Fast and convenient access to medications</li>
            <li>
              Help with insurance navigation and financial assistance options
            </li>
            <li>Proactive communication about medication refills</li>
            <li>Education on how to manage side effects</li>
          </ul>
        </p>
        <p className="highlight">
          Ask your care team about your in-house dispensing option or call our
          MID team at{" "}
          <b>
            <a href="tel:8592051733">(859) 205-1733</a>
          </b>
          .
        </p>
        <h3>FAQ about our MID (Medical Integrated Dispensing) Program</h3>
        <p>
          <b>Do you accept my prescription insurance?</b>
          <br />
          We can fill most prescription insurances for patients who use Medicare
          and Medicare Advantage and some commercial plans. If you’re curious
          about whether we can fill for you – reach out to us at{" "}
          <b>
            <a href="tel:8592051733">(859) 205-1733</a>
          </b>
          .
        </p>
        <p>
          <b>What kind of medications can I fill with you?</b>
          <br />
          We can fill your prescriptions for specialty medications such as oral
          and self injectable rheumatologic treatments as well as other select
          medications. In cases where we cannot fill your prescription in-house,
          we can help you navigate your insurance benefits, find financial
          assistance, manage side effects, and more.
        </p>
        <p>
          <b>How long will it take to receive my medication?</b>
          <br />
          We fill your prescription as quickly as possible by supporting you
          through insurance approvals and arranging convenient in-clinic pickup
          for your medication. Most patients receive their medication within 2-5
          days from receiving a prescription from their doctor. If you would
          like to know the status of your prescription please call us at{" "}
          <b>
            <a href="tel:8592051733">(859) 205-1733</a>
          </b>
          .
        </p>
        <p>
          <b>How will I know when my prescription is ready?</b>
          <br />
          WWe will coordinate with you on pick-up options when we’re scheduling
          the order and provide you updates on the status. If you would like to
          check on a prescription please call us at{" "}
          <b>
            <a href="tel:8592051733">(859) 205-1733</a>
          </b>
          .
        </p>
        <p>
          <b>What do I do if I think my medication is causing side effects?</b>
          <br />
          If you are feeling unwell or experiencing side effects, please call us
          at{" "}
          <b>
            <a href="tel:8592051733">(859) 205-1733</a>
          </b>
          . Our pharmacists are knowledgeable about your medical history,
          potential side effects, and can quickly get in touch with your doctor.
        </p>
        <p>
          <b>I have a question about my medication. Who should I contact?</b>
          <br />
          Please call us at{" "}
          <b>
            <a href="tel:8592051733">(859) 205-1733</a>
          </b>{" "}
          to reach a pharmacist who is knowledgeable about your condition and
          prescribed medication.
        </p>
        <p>
          <b>Will it cost me more to fill my prescription with you?</b>
          <br />
          In most cases, patients save money by filling their prescriptions with
          us. We take on the work of verifying your insurance coverage before
          dispensing your medication and will be able to give you more
          information about the out-of-pocket cost. If you need assistance, we
          can investigate financial support options on your behalf.
        </p>
        <p>
          <b>I cannot afford my medication. What should I do?</b>
          <br />
          Our team understands the importance of getting you your medications
          quickly and affordably and there are a number of financial assistance
          options we can explore. When filling with our in-house MID, a care
          coordinator who is knowledgeable in financial assistance for your
          medication will work with you to determine the best options.
        </p>
        <p>
          <b>What are the benefits of filling my prescription with you?</b>
          <br />
          Filling your prescription with our practice, allows you to receive
          your medication quickly while making sure your financial needs are
          met. Being able to dispense your medication and help coordinate
          refills for you allows us to monitor your care and intervene if you
          experience side effects. We also know that navigating insurance and
          financial assistance can be overwhelming. Let us do that for you so
          you can focus on your health.
        </p>
      </article>
    </section>
  );
};

export default ClinicMedications;
